<div class="container d-flex justify-content-center mt-4">
    <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status"></div>
</div>